class {
  onInput(input) {
    this.state = { checked: input.checked || false };
  }
  handleToggle() {
    this.state.checked = !this.state.checked;
    this.emit('toggle', {
      checked: this.state.checked,
      type: this.input.type,
      role: this.input.role,
      perm: this.input.perm,
      bit: this.input.bit,
      preset: this.input.preset,
      option: this.input.option,
    });
  }
}

<button
  on-click('handleToggle')
  class=(`
    px-3 py-2 rounded-md text-sm font-medium transition border w-full
    ${state.checked ? 'bg-green-400/40 border-green-500 text-white ' : 'bg-gray-800 border-gray-600 text-gray-300 '}
    ${input.disabled ? 'opacity-50 cursor-not-allowed ' : 'hover:bg-gray-700 cursor-pointer '}
    ${input.class || ''}
  `)
  bubble
  disabled=input.disabled
>
  ${input.label}
</button>
